module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAA4ElEQVRoge3Y0QnCMBRG4VNxAEdxgL64iRMUMongQn1xAEdxg0gg4IuCaa5JrvznuZT7QapJUEoppTw3tZw9LvMBuABhut4eFu/cWbykoDT8GVgzprrWgADcgaMVoukS4rWM1oxImFPNcmoOwBjRBYAhohsAI0RXQKoW0R1AJWIIABWIYQBsRAwFYANiOACFiCEBFCA+AuIyx59PWdZbROvNnHn/u4R65vojdv0z6vqPzPVWwvVmzvV22vWBxvWR0vWh3vW1ivXwdLpaNBs+tbeZ6+tCftDsclcppZTyG/AEdVujtuDP6JAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/@2x/ic_btn_arrow2@2x.png
// module id = 304
// module chunks = 0